import React from "react";
import { Link } from "react-router-dom";

export default function Partners() {
    return (
        <div className="container">
            <div className="home-container">
                <h1 className="home-text">RAYTOLFAS - ПАРТНЁРКИ</h1>
            </div>

            <div className="content-container">
                <h1>EasyLiker</h1>
                <Link className="Link-button-header" to="https://easyliker.ru/register?ref=MIXITOSIK">Перейти</Link>
            </div>

            <div className="content-container">
                <h1>1WIN-Partners</h1>
                <Link className="Link-button-header" to="https://1win.run/?p=HEpe">Перейти</Link>
            </div>

            <div className="content-container">
                <h1>Hosting-Minecraft</h1>
                <Link className="Link-button-header" href="https://my.hosting-minecraft.pro/aff.php?aff=7125" target="_blank">Перейти</Link>
            </div>
        </div>
    );
}
